/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nhs/house': {
    width: 55,
    height: 55,
    viewBox: '0 0 55 55',
    data: '<circle pid="0" cx="27.5" cy="27.5" r="27.5" _fill="#4547BF"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M37.946 37v-9.788l-10.232-8.068-10.233 8.068v9.787L25.49 37v-6.897h4.448V37h8.008z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M15.438 27.683l12.275-9.679 12.35 9.738 1.484-1.882-3.654-2.881v-7.286h-4.707v3.575L27.774 15 14 25.86l1.438 1.823z" _fill="#fff"/>'
  }
})
